import React, { useEffect, useState } from 'react';
import {
  Col,
  Input,
  Row,
  Typography,
  Select,
  Card,
  Space,
  Avatar,
  Progress,
  Button,
  Badge,
  Tag,
  Popconfirm
} from 'antd';
import {
  AreaChartOutlined,
  ArrowLeftOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  MinusCircleOutlined,
  SearchOutlined,
  SlidersOutlined,
  SwapOutlined,
  UserAddOutlined
} from '@ant-design/icons';
import styles from './index.module.less';
import ColorHash from 'color-hash';
import AssignmentModal from './AssignmentModal';
import AddMemberModal from './AddMemberModal';
import CustomButton from '@/common/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchStaffingData,
  selectStaffingSlice,
  fetchStaffingUsers,
  deleteStaffAssignment,
  updateStaffAssignment,
  fetchUserRoles
} from '../redux/slice';
import { getAllClients } from 'pages/Tasks/redux/slice';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import EditMemberModal from './EditMemberModal';

const colorHash = new ColorHash({ lightness: 0.7 });

const { Title, Text } = Typography;

// Helper to get initials like "SJ" from "Sarah Johnson"
const getInitials = (name) =>
  name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase();

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = Math.floor(
    Math.abs(Math.sin(hash) * 16777215) % 16777215
  ).toString(16);
  return `#${'000000'.substring(0, 6 - color.length) + color}`;
};
const groupAssignmentsByProject = (projects, roles) => {
  const projectMap = {};

  projects.forEach((project, index) => {
    const { id: projectId, project: projectTitle, client, staffings } = project;

    if (!projectId || !projectTitle) {
      console.warn(`Skipping invalid project at index ${index}:`, project);
      return;
    }

    if (!projectMap[projectId]) {
      projectMap[projectId] = {
        projectTitle,
        company: client?.client_name || 'Unknown Company',
        projectId,
        members: []
      };
    }

    staffings?.forEach((staffing, staffIndex) => {
      const user = staffing.user;
      if (!user) {
        console.warn(
          `Skipping invalid staffing at index ${staffIndex}:`,
          staffing
        );
        return;
      }

      const roleName =
        roles.find((r) => r.id === staffing.project_role_master_id)?.role ||
        'Member';

      projectMap[projectId].members.push({
        id: staffing.id,
        name: `${user.first_name} ${user.last_name}`,
        progress: staffing.utilization_percentage,
        role: roleName,
        utilization_type: staffing.utilization_type // ✅ Add this line
      });
    });
  });

  return Object.values(projectMap);
};

const StaffingPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [addMemberModalOpen, setAddMemberModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [sortByLowToHigh, setSortByLowToHigh] = useState(false);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');

  const [editMemberModalOpen, setEditMemberModalOpen] = useState(false);
  const [selectedEditMember, setSelectedEditMember] = useState(null);
  const [selectedEditProject, setSelectedEditProject] = useState(null);

  const [selectedRole, setSelectedRole] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, projects, users, roles, count } =
    useSelector(selectStaffingSlice);

  console.log(roles, 'roles');
  console.log(count, 'count');

  useEffect(() => {
    dispatch(getAllClients()).then((res) => {
      const data = res?.payload;
      if (Array.isArray(data)) {
        setClients(data);
      } else if (Array.isArray(data?.data)) {
        setClients(data.data);
      } else {
        console.warn('Unexpected client data:', data);
        setClients([]);
      }
    });
  }, [dispatch]);

  console.log(projects, 'projects');

  useEffect(() => {
    dispatch(fetchStaffingData());
    dispatch(fetchStaffingUsers());
    dispatch(fetchUserRoles());
  }, [dispatch]);

  console.log('users', users);

  const handleAssignClick = (member) => {
    setSelectedMember(member);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedMember(null);
  };

  const handleAddMemberClick = (project) => {
    console.log('project in main page ', project);
    setSelectedProject(project);
    setAddMemberModalOpen(true);
  };

  const handleAddMemberModalClose = () => {
    setAddMemberModalOpen(false);
    setSelectedProject(null);
  };

  const groupedProjects = useMemo(() => {
    return groupAssignmentsByProject(projects, roles);
  }, [projects, roles]);

  const filteredProjects = useMemo(() => {
    return groupedProjects
      .filter((proj) => {
        const matchesSearch = proj.projectTitle
          .toLowerCase()
          .includes(searchText.toLowerCase());

        const matchesClient =
          selectedClient === '' || proj.company === selectedClient;

        return matchesSearch && matchesClient;
      })
      .map((proj) => {
        const filteredMembers = proj.members.filter((member) =>
          selectedRole ? member.role === selectedRole : true
        );

        return {
          ...proj,
          members: filteredMembers
        };
      });
  }, [groupedProjects, searchText, selectedClient, selectedRole]);

  // const members = useMemo(() => {
  //   return users.map((userItem) => {
  //     const staffings = userItem.staffings || [];

  //     const totalUtilization = staffings.reduce(
  //       (sum, s) => sum + (s.utilization_percentage || 0),
  //       0
  //     );

  //     const utilizationType =
  //       staffings.find((s) => s.utilization_type)?.utilization_type ||
  //       'Available';

  //     const projectUtilization = staffings.map((s) => ({
  //       projectId: s.project?.id,
  //       projectName: s.project?.project || 'Unnamed Project',
  //       clientName: s.project?.client?.client_name || 'Unknown Client',
  //       utilization: s.utilization_percentage || 0,
  //       utilization_type: s.utilization_type || 'active',
  //       roleName:
  //         roles.find((r) => r.id === s.project_role_master_id)?.role || 'Member'
  //     }));

  //     return {
  //       id: userItem.id,
  //       name: `${userItem.first_name || ''} ${userItem.last_name || ''}`.trim(),
  //       workload: totalUtilization,
  //       status: utilizationType,
  //       // statusColor: totalUtilization >= 70 ? 'gold' : 'green',
  //       statusColor:
  //         utilizationType === 'active'
  //           ? 'yellow'
  //           : utilizationType === 'upcoming'
  //           ? 'blue'
  //           : 'green',
  //       projects: projectUtilization
  //     };
  //   });
  // }, [users, roles]);
  const members = useMemo(() => {
    return users.map((userItem) => {
      const staffings = userItem.staffings || [];

      const totalUtilization = staffings.reduce(
        (sum, s) => sum + (s.utilization_percentage || 0),
        0
      );

      let status = 'Available';
      let statusColor = 'green';

      if (totalUtilization >= 80 && totalUtilization <= 100) {
        status = 'Optimal';
        statusColor = 'blue';
      } else if (totalUtilization > 100) {
        status = 'Overloaded';
        statusColor = 'red';
      }

      const projectUtilization = staffings.map((s) => ({
        projectId: s.project?.id,
        projectName: s.project?.project || 'Unnamed Project',
        clientName: s.project?.client?.client_name || 'Unknown Client',
        utilization: s.utilization_percentage || 0,
        utilization_type: s.utilization_type || 'active',
        roleName:
          roles.find((r) => r.id === s.project_role_master_id)?.role || 'Member'
      }));

      return {
        id: userItem.id,
        name: `${userItem.first_name || ''} ${userItem.last_name || ''}`.trim(),
        workload: totalUtilization,
        status,
        statusColor,
        projects: projectUtilization
      };
    });
  }, [users, roles]);

  const sortedMembers = useMemo(() => {
    const membersCopy = [...members];
    if (sortByLowToHigh) {
      return membersCopy.sort((a, b) => a.workload - b.workload);
    }
    return membersCopy;
  }, [members, sortByLowToHigh]);

  const handleSortClick = () => {
    setSortByLowToHigh((prev) => !prev);
  };

  const handleDeleteUser = (memberId) => {
    dispatch(deleteStaffAssignment({ id: memberId, type: 'delete' })).then(
      (res) => {
        if (res?.payload?.success) {
          dispatch(fetchStaffingData());
          dispatch(fetchStaffingUsers());
        }
      }
    );
    console.log('delete id ', memberId);
  };

  const handleEditMemberClick = (member, project) => {
    setSelectedEditMember(member);
    setSelectedEditProject(project);
    setEditMemberModalOpen(true);
  };

  return (
    <section className={'mb-12 overflow-hidden md:overflow-y-auto'}>
      <div className="flex flex-row justify-between">
        <div>
          <Title level={5} className="!text-xl !m-0 lg:!text-3xl !font-bold">
            Manage Staffing
          </Title>
        </div>
        <div>
          <CustomButton
            type="outlined"
            onClick={() => navigate('/plan-staffing')}
          >
            <ArrowLeftOutlined /> Back to Staffing
          </CustomButton>
        </div>
      </div>

      <br />

      <Row gutter={24}>
        <Col span={12}>
          <div className={`bg-[#fff] relative rounded-lg shadow-bottom p-6`}>
            <Title
              level={5}
              style={{
                margin: 0,
                color: '#666',
                fontWeight: 'bold',
                fontSize: '14px',
                marginBottom: '16px'
              }}
              className="!whitespace-nowrap "
            >
              PROJECTS
            </Title>
            <Row gutter={16} className="!sticky !top-0">
              {/* <Col span={6}>
                <Select
                  showSearch
                  placeholder="All Clients"
                  optionFilterProp="children"
                  style={{ width: '100%' }}
                  value={selectedClient}
                  onChange={(value) => setSelectedClient(value)}
                >
                  <Select.Option value="">All Clients</Select.Option>
                  {clients.map((client) => (
                    <Select.Option key={client.id} value={client.client_name}>
                      {client.client_name}
                    </Select.Option>
                  ))}
                </Select>
              </Col>
              <Col span={6}>
                <Select
                  showSearch
                  placeholder="All Roles"
                  optionFilterProp="children"
                  style={{ width: '100%' }}
                  value={selectedRole}
                  onChange={(value) => setSelectedRole(value)}
                >
                  <Select.Option value="">All Roles</Select.Option>
                  {roles.map((role) => (
                    <Select.Option key={role.id} value={role.role}>
                      {role.role}
                    </Select.Option>
                  ))}
                </Select>
              </Col> */}

              <Col span={8}>
                <Select
                  showSearch
                  placeholder="All Clients"
                  optionFilterProp="children"
                  style={{ width: '100%' }}
                  value={selectedClient}
                  onChange={(value) => {
                    setSelectedClient(value);
                    setSelectedRole(''); // Clear previously selected role when client changes
                  }}
                >
                  <Select.Option value="">All Clients</Select.Option>
                  {clients.map((client) => (
                    <Select.Option key={client.id} value={client.client_name}>
                      {client.client_name}
                    </Select.Option>
                  ))}
                </Select>
              </Col>

              {/* <Col span={6}>
                <Select
                  showSearch
                  placeholder="All Roles"
                  optionFilterProp="children"
                  style={{ width: '100%' }}
                  value={selectedRole}
                  onChange={(value) => setSelectedRole(value)}
                  disabled={!selectedClient} // disable roles unless a client is selected
                >
                  <Select.Option value="">All Roles</Select.Option>
                  {roles.map((role) => (
                    <Select.Option key={role.id} value={role.role}>
                      {role.role}
                    </Select.Option>
                  ))}
                </Select>
              </Col> */}

              <Col span={16}>
                <Input
                  placeholder="Search projects..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  prefix={<SearchOutlined />}
                />
              </Col>

              <div
                style={{ padding: '18px 11px', marginTop: '10px' }}
                className="w-full max-h-[710px] overflow-y-auto"
              >
                {filteredProjects.map((project, index) => (
                  <Card
                    key={index}
                    style={{ marginBottom: 24, borderRadius: 6 }}
                    bodyStyle={{ padding: '12px 15px' }}
                    className="shadow-bottom"
                  >
                    <Row className="flex justify-between">
                      <div>
                        <Text className="text-sm text-gray-800 font-semibold">
                          {project.projectTitle}
                        </Text>
                      </div>
                    </Row>

                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {project.company}
                    </Text>
                    <div style={{ marginTop: 4 }}>
                      {project.members.length === 0 ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'rgb(187, 187, 187)',
                            fontWeight: 600
                          }}
                        >
                          <Text type="secondary" style={{ fontSize: 11 }}>
                            No member assigned
                          </Text>
                        </div>
                      ) : (
                        project.members.map((member, idx) => (
                          <div
                            key={idx}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              backgroundColor:
                                member.utilization_type === 'upcoming'
                                  ? '#e6f0ff'
                                  : '#F8F9FA',
                              padding: '8px 16px',
                              borderRadius: 6,
                              marginBottom: 8
                            }}
                          >
                            <Space>
                              <div>
                                <Text className="font-semibold">
                                  {member.name}
                                </Text>
                                <div style={{ marginTop: '-6px' }}>
                                  <Text
                                    type="secondary"
                                    style={{ fontSize: 11 }}
                                  >
                                    {member.role}
                                  </Text>
                                </div>
                              </div>
                            </Space>
                            <div>
                              {/* <Badge
                                count={`${member.progress}%`}
                                style={{
                                  color: '#4169e1',
                                  backgroundColor: '#e6f0ff',
                                  border: '1px solid #4169e1',
                                  fontSize: '10px',
                                  fontWeight: 600,
                                  marginRight: '4px'
                                }}
                              /> */}
                              <Badge
                                className="px-2 py-[4px] rounded-full"
                                count={`${member.progress}%`}
                                style={{
                                  color: '#4169e1',
                                  backgroundColor: '#e6f0ff',
                                  border: '1px solid #4169e1',
                                  fontSize: '11px',
                                  fontWeight: 600,
                                  minWidth: 40,
                                  textAlign: 'center',
                                  lineHeight: '1.2',
                                  padding: '4px 8px'
                                }}
                              />

                              <span>
                                <EditOutlined
                                  style={{ color: 'gray' }}
                                  className="pl-1 hover:bg-gray-200 cursor-pointer p-1"
                                  onClick={() =>
                                    handleEditMemberClick(member, project)
                                  }
                                />
                              </span>
                              <span>
                                {/* <MinusCircleOutlined
                                  style={{ color: 'gray', fontSize: '12px' }}
                                  onClick={() => handleDeleteUser(member.id)}
                                  className=" hover:bg-gray-200 cursor-pointer p-1"
                                /> */}
                                <Popconfirm
                                  title={
                                    <>
                                      <div>Please Confirm</div>
                                      <div
                                        style={{ color: 'rgba(0, 0, 0, 0.45)' }}
                                      >
                                        Do you want to remove this assignment?
                                      </div>
                                    </>
                                  }
                                  onConfirm={() => handleDeleteUser(member.id)}
                                  okText="Remove"
                                  cancelText="No"
                                >
                                  <DeleteOutlined
                                    style={{ color: 'gray', fontSize: '12px' }}
                                    className="hover:bg-gray-200 cursor-pointer p-1"
                                  />
                                </Popconfirm>
                              </span>
                            </div>
                          </div>
                        ))
                      )}
                    </div>

                    <div className={styles.addbb}>
                      {/* <UserAddOutlined
                        style={{ color: 'gray' }}
                        onClick={() => handleAddMemberClick(project)}
                        className=" hover:bg-gray-200 cursor-pointer p-1 "
                      /> */}
                      <Button
                        type="link"
                        className={styles.assign}
                        onClick={() => handleAddMemberClick(project)}
                        style={{
                          padding: 0,
                          height: 'auto',
                          border: 'none',
                          fontSize: '12px'
                        }}
                      >
                        Assign
                      </Button>
                    </div>
                  </Card>
                ))}
              </div>
            </Row>
          </div>
        </Col>
        <Col span={12}>
          <div className="bg-[#fff] relative rounded-lg shadow-bottom p-6 max-h-[800px] overflow-y-auto">
            <div className="flex justify-between mb-3">
              <Title
                level={5}
                style={{
                  margin: 0,
                  color: '#666',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}
                className="!whitespace-nowrap"
              >
                TEAM MEMBERS
              </Title>
              <span
                onClick={handleSortClick}
                className={`${styles.assign} hover:bg-gray-100 cursor-pointer text-xs pr-[18px]`}
              >
                <SwapOutlined className="rotate-90" /> Sort by Availability
              </span>
            </div>

            <div>
              {sortedMembers.map((member, index) => (
                <Card
                  key={index}
                  style={{ marginBottom: 16, backgroundColor: '#F8F9FA' }}
                  bodyStyle={{ padding: '8px 16px' }}
                >
                  <div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 12
                        }}
                      >
                        <Avatar
                          style={{
                            backgroundColor: colorHash.hex(member.name)
                          }}
                        >
                          {getInitials(member.name)}
                        </Avatar>
                        <div>
                          <Text className="text-gray-800 font-semibold">
                            {member.name}
                          </Text>
                        </div>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8
                        }}
                      >
                        {/* <span
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            backgroundColor:
                              member.statusColor === 'gold'
                                ? '#faad14'
                                : '#52c41a',
                            display: 'inline-block'
                          }}
                        /> */}
                        <span
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            backgroundColor:
                              member.statusColor === 'green'
                                ? '#52c41a' // Available
                                : member.statusColor === 'blue'
                                ? '#1890ff' // Optimal
                                : '#ff4d4f', // Overloaded (red)
                            display: 'inline-block'
                          }}
                        />

                        <Text
                          type="secondary"
                          style={{ fontSize: 12, paddingRight: '12px' }}
                        >
                          {member.status.charAt(0).toUpperCase() +
                            member.status.slice(1)}
                        </Text>
                      </div>
                    </div>

                    <div style={{ marginTop: 12 }}>
                      {/* Project-wise Utilization */}
                      {member.projects?.length > 0 ? (
                        <div className="bg-white py-2 px-4 rounded-[10px]">
                          <div className="flex justify-end">
                            <Text type="secondary" style={{ fontSize: 12 }}>
                              Project-wise Utilization
                            </Text>
                          </div>
                          <div style={{ marginTop: 6 }}>
                            {member.projects.map((proj, projIdx) => (
                              <div
                                key={projIdx}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  fontSize: 12,
                                  marginBottom: 6,
                                  // backgroundColor: '#F8F9FA',
                                  backgroundColor:
                                    proj.utilization_type === 'upcoming'
                                      ? '#e6f0ff'
                                      : '#F8F9FA',
                                  padding: '4px 8px',
                                  borderRadius: 7
                                }}
                              >
                                <div>
                                  <Text className="text-sm text-gray-800 font-semibold">
                                    {proj.projectName}

                                    <Text
                                      type="secondary"
                                      style={{
                                        fontSize: '12px',
                                        paddingLeft: '5px'
                                      }}
                                    >
                                      {' ·'} {proj.clientName} {' ·'}
                                    </Text>
                                  </Text>
                                  <div style={{ marginTop: '-3px' }}>
                                    <Text
                                      type="secondary"
                                      style={{ fontSize: 11 }}
                                    >
                                      {proj.roleName}
                                    </Text>

                                    {/* <Text
                                      type="secondary"
                                      style={{
                                        fontSize: '12px',
                                        // paddingLeft: '5px'
                                      }}
                                    >
                                      {proj.clientName}
                                    </Text> */}
                                  </div>
                                </div>

                                {/* <Badge
                                  className="py-[7px] px-0"
                                  count={`${proj.utilization}%`}
                                  style={{
                                    color: '#4169e1',
                                    backgroundColor: '#e6f0ff',
                                    border: '1px solid #4169e1',
                                    fontSize: '10px',
                                    fontWeight: 600
                                  }}
                                /> */}
                                <Badge
                                  className="px-2 py-[4px] rounded-full"
                                  count={`${proj.utilization}%`}
                                  style={{
                                    color: '#4169e1',
                                    backgroundColor: '#e6f0ff',
                                    border: '1px solid #4169e1',
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    minWidth: 40,
                                    textAlign: 'center',
                                    lineHeight: '1.2',
                                    padding: '4px 8px'
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div
                          // className="bg-white py-2 px-4 rounded-[10px]"
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'rgb(187, 187, 187)',
                            fontWeight: 600
                          }}
                        >
                          <Text type="secondary" style={{ fontSize: 11 }}>
                            Available for projects
                          </Text>
                        </div>
                      )}

                      <div className={styles.addb}>
                        <Button
                          type="link"
                          className={styles.assign}
                          onClick={() => handleAssignClick(member)}
                          style={{
                            padding: 0,
                            height: 'auto',
                            border: 'none',
                            fontSize: '12px'
                          }}
                        >
                          Assign
                        </Button>
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </Col>
      </Row>

      <AssignmentModal
        visible={modalOpen}
        open={modalOpen}
        onClose={handleModalClose}
        member={selectedMember}
      />

      <AddMemberModal
        visible={addMemberModalOpen}
        open={addMemberModalOpen}
        onClose={handleAddMemberModalClose}
        project={selectedProject}
      />

      <EditMemberModal
        visible={editMemberModalOpen}
        open={editMemberModalOpen}
        onClose={() => {
          setEditMemberModalOpen(false);
          setSelectedEditMember(null);
          setSelectedEditProject(null);
        }}
        member={selectedEditMember}
        project={selectedEditProject}
      />
    </section>
  );
};

export default StaffingPage;
